import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormService, LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {ApiService} from '../../shared/services/api.service';

@Component({
  selector: 'app-magic-link-login',
  templateUrl: './magic-link-login.component.html',
  styleUrls: ['./magic-link-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MagicLinkLoginComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  inputType: 'email' | 'phone' = 'email';
  linkSent = false;
  isEmailEnabled: boolean;
  isSmsEnabled: boolean;
  showInputTypeSelector: boolean;

  constructor(
    public nav: NavigateService,
    public forms: FormService,
    public api: ApiService,
    private formBuilder: FormBuilder,
    private lang: LangService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    this.isEmailEnabled = this.api.env.enableMagicLinkLoginByEmail ?? false;
    this.isSmsEnabled = this.api.env.enableMagicLinkLoginBySms ?? false;
    this.showInputTypeSelector = this.isEmailEnabled && this.isSmsEnabled;

    if (!this.isEmailEnabled && this.isSmsEnabled) {
      this.inputType = 'phone';
    } else if (this.isEmailEnabled && !this.isSmsEnabled) {
      this.inputType = 'email';
    }
    
    this.setForm();
  }

  setForm() {
    this.form = this.formBuilder.group({
      account: ['', [Validators.required]]
    });
    this.updateValidators();
  }

  updateValidators() {
    const accountControl = this.form.get('account');
    if (this.inputType === 'email') {
      accountControl.setValidators([Validators.required, Validators.email]);
    }
    if (this.inputType === 'phone') {
      accountControl.setValidators([Validators.required]);
    }
  }

  onInputTypeChange(type: 'email' | 'phone') {
    this.inputType = type;
    this.updateValidators();
    this.submitted = false;
    this.linkSent = false;
  }

  phoneSelected(phone: string) {
    this.form.get('account').setValue(phone);
  }

  submitForm() {
    this.submitted = true;
    if (this.forms.getFormErrors(this.form).length < 1) {
      this.loader.loading(true);
      this.sendMagicLink();
    }
  }

  sendMagicLink() {
    this.api.sendMagicLink(this.form.get('account')?.value?.replace(/[()]/g, '')).then(() => {
      this.linkSent = true;
      this.loader.loading(false);
    }).catch((err) => {
      this.submitted = false;
      this.loader.loading(true, {type: 'error', message: this.lang.transform(err) || err});
    });
  }

  resetForm() {
    this.form.reset();
    this.submitted = false;
    this.linkSent = false;
  }
}
